/**
 * Storefront Session
 *
 * Per-brand storage for the customer-side JWT. When a brand has its own
 * custom domain, browser storage is naturally per-origin so no scoping is
 * needed; when several brands are previewed under `/site/:brandRef/...`
 * on the platform domain we key by brand id so each brand keeps its own
 * session.
 *
 * Storage key: `tpo_customer_session_<brand_id>`.
 */

const KEY_PREFIX = 'tpo_customer_session_';

const storage = typeof window !== 'undefined' ? window.localStorage : null;

export function saveSession(brandId, session) {
  if (!storage || !brandId || !session) return;
  try {
    storage.setItem(KEY_PREFIX + brandId, JSON.stringify(session));
  } catch (_) { /* quota / private mode */ }
}

export function loadSession(brandId) {
  if (!storage || !brandId) return null;
  try {
    const raw = storage.getItem(KEY_PREFIX + brandId);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

export function clearSession(brandId) {
  if (!storage || !brandId) return;
  try { storage.removeItem(KEY_PREFIX + brandId); } catch (_) {}
}
